export enum Citizenship {
  'OUTSIDE_UE' = 1,
  'UE',
}
